import Vue from "vue";
import Router from "vue-router";
const ThemePagePage = () => import("./views/Page.vue")
const ThemeHomePage = () => import("./views/Home.vue")
const ThemePosts = () => import("./views/Projects.vue")
const ThemePost = () => import("./views/Project.vue")
// const ThemeContactPage = () => import("./views/Contact.vue")
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: '/projekty', component: ThemePosts, meta: { inverted: false } },
    { path: '/projekt/:page', component: ThemePost, meta: { inverted: true } },
    {
      path: '/wp-admin', beforeEnter() {
        window.location = "http://ama.annamiller-architekci.pl/wp-admin/"
      }
    },
    { path: '/:page', component: ThemePagePage, meta: { inverted: true } },
    { path: '/', name: 'Home', component: ThemeHomePage, meta: { inverted: false } },

  ],
  scrollBehavior(to) {
    if (to.hash) {
      return window.scrollTo({ top: document.querySelector(to.hash).offsetTop, behavior: 'smooth' });
    }
    return window.scrollTo({ top: 0, behavior: 'smooth' });
  }
});

export default router
